export default __webpack_public_path__ + "static/media/be.7806d0cb.svg";